import { render, staticRenderFns } from "./FlowVoucherDetail.vue?vue&type=template&id=9c9215a0&scoped=true&"
import script from "./FlowVoucherDetail.vue?vue&type=script&lang=js&"
export * from "./FlowVoucherDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9215a0",
  null
  
)

export default component.exports